// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__2qkyL","banner__fig":"Banner_banner__fig__3kLBv","banner__content":"Banner_banner__content__dLB3R"};